"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Dropped from "../../../../public/Images/dropped.svg";
import getBlogs from "@/app/lib/getBlogs";

import "./style.css";

export default function Page() {
  const [blogs, setblogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const blogs = await getBlogs();
      setblogs(blogs?.reverse());
    };

    fetchData();
  }, []);
  return (
    <div className="dropped-container">
      <div className="dropped-header flex items-center">
        <Image
          src={Dropped}
          alt="Just Dropped Banner"
          className="Dropped-img"
          width={100}
          height={100}
        />
        <h1>
          <span>Just</span> <br />
          Dropped
        </h1>
      </div>

      {blogs &&
        Array.isArray(blogs) &&
        blogs.length >= 0 &&
        blogs?.slice(0, 3)?.map((blogs, index) => (
          <div className="dropped-main-card">
            <Link href={`/ReadBlog/${blogs?._id}`}>
              <div className="dropped-time flex gap-2 items-center">
                <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight text-[16px] font-semibold">
                  {blogs.category}
                </h1>
                <p>{blogs?.date}</p>
              </div>
              <div className="dropped-card">
                <img
                  src={blogs?.thumbnail}
                  alt={blogs.title}
                  className="DroppedMen-img"
                />
                <div className="dropped-card-content">
                  <h1 className="text-[16px] font-medium poppins">
                    {blogs?.title?.length > 20
                      ? blogs.title.substring(0, 20) + "..."
                      : blogs.title}
                  </h1>
                  <p className="uppercase font-[400] mt-1 w-full text-[12px] poppins">
                    BY&nbsp;{blogs?.author}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))}
    </div>
  );
}
